// src/tour/scripts/index.js
//
// Script registry. Adding a new tour = add a script file and register it here.
// Nothing else in the engine changes. This is the seam that lets the vendor
// marketplace / work-order / services tours land later without touching
// TourContext, the overlay, or the launcher.

import { welcomeScript } from './welcomeScript'

const SCRIPTS = {
  [welcomeScript.id]: welcomeScript,
  // future: [roomsScript.id]: roomsScript, [workOrdersScript.id]: workOrdersScript, ...
}

/** @returns {object|null} the script for a tourId, or null if unregistered. */
export function getScript(tourId) {
  return SCRIPTS[tourId] || null
}

/**
 * @returns {Array<{id, name, estimatedMinutes, endsWith, stepCount}>}
 * Lightweight metadata for the launcher — no step bodies.
 */
export function listAvailableTours() {
  return Object.values(SCRIPTS).map(s => ({
    id: s.id,
    name: s.name,
    estimatedMinutes: s.estimatedMinutes,
    endsWith: s.endsWith,
    stepCount: (s.steps || []).filter(st => st.countsTowardProgress).length,
  }))
}
